import { Component, OnInit } from '@angular/core';
import { HostListener } from "@angular/core";

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.less']
})
export class NavComponent implements OnInit {
  reachedBottom:boolean;
  constructor() { }

  ngOnInit() {
    this.reachedBottom = false;
  }

  arrowClicked() {
    // Scroll to gallery. This can be made generic later.
    // TODO: not best practice.
    document.getElementById('gallery').scrollIntoView({behavior: 'smooth'});
  }

  @HostListener('window:scroll', ['$event']) 
  handleScroll($event) {
    function getDocHeight() {
      var D = document;
      return Math.max(
          D.body.scrollHeight, D.documentElement.scrollHeight,
          D.body.offsetHeight, D.documentElement.offsetHeight,
          D.body.clientHeight, D.documentElement.clientHeight
      )
    }
    var dh = getDocHeight();
    var gallery = document.getElementById('gallery');
    console.log(gallery.scrollHeight);
    console.log(window.pageYOffset - window.innerHeight);

    var pixelsRemaining= dh - (window.pageYOffset + window.innerHeight);
    if (pixelsRemaining < 100) {
      this.reachedBottom = true;
    } else {
      this.reachedBottom = false;
    }
  }
}
